import { syntheticVisit } from "./synthetic-visit";

const fields = {
	visit_started: {
		entry: [
			"direct",
			"search",
			"shared_link",
			"poll",
			"home_screen",
			"toss_miniapp",
		],
	},
	first_value_seen: { kind: ["facts_only", "with_tips"] },
	return_visit: { bucket: ["d1_6", "d7_13", "d14_29", "d30_plus"] },
	share_completed: { method: ["link", "image", "poll"] },
	pass_intent: { trigger: ["watch_limit", "poll_limit", "settings"] },
	tip_published: {
		entry: ["seat", "next_day", "request_list", "row"],
		photo: [true, false],
	},
} as const;
export function completionEvent(
	event: keyof typeof fields,
	signal: Record<string, string | boolean>,
) {
	const schema = fields[event] as Record<string, readonly (string | boolean)[]>;
	if (
		Object.keys(signal).length !== Object.keys(schema).length ||
		Object.entries(schema).some(
			([key, values]) => !values.includes(signal[key] as never),
		)
	)
		return;
	void fetch("/api/events", {
		method: "POST",
		headers: { "content-type": "application/json" },
		body: JSON.stringify({
			event,
			occurredAt: new Date().toISOString(),
			...signal,
			synthetic: syntheticVisit(),
		}),
		keepalive: true,
	}).catch(() => undefined);
}
export function firstValueSeen(withTips = false) {
	try {
		if (localStorage.getItem("anjabom.first-value.v1")) return;
		completionEvent("first_value_seen", {
			kind: withTips ? "with_tips" : "facts_only",
		});
		localStorage.setItem("anjabom.first-value.v1", new Date().toISOString());
	} catch {}
}
export function visitStarted(toss: boolean) {
	try {
		if (sessionStorage.getItem("anjabom.visit.v1")) return;
		sessionStorage.setItem("anjabom.visit.v1", "1");
		const entry = toss
			? "toss_miniapp"
			: location.pathname.startsWith("/p/")
				? "poll"
				: matchMedia("(display-mode: standalone)").matches
					? "home_screen"
					: document.referrer && /google\.|naver\./.test(document.referrer)
						? "search"
						: location.pathname.startsWith("/seat/")
							? "shared_link"
							: "direct";
		completionEvent("visit_started", { entry });
		const today = new Date().toISOString().slice(0, 10),
			first = localStorage.getItem("anjabom.first-visit.v1");
		if (!first) localStorage.setItem("anjabom.first-visit.v1", today);
		else if (
			first !== today &&
			localStorage.getItem("anjabom.return-day.v1") !== today
		) {
			const days = Math.floor(
				(Date.parse(today) - Date.parse(first)) / 86_400_000,
			);
			completionEvent("return_visit", {
				bucket:
					days < 7
						? "d1_6"
						: days < 14
							? "d7_13"
							: days < 30
								? "d14_29"
								: "d30_plus",
			});
			localStorage.setItem("anjabom.return-day.v1", today);
		}
	} catch {}
}
